import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Login.css";
import "./Policy.css";

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-page">
      <Link to="/login" className="policy-back">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M19 12H5M12 5l-7 7 7 7"/>
        </svg>
        Back to Login
      </Link>

      <div className="centered-logo-container">
        <div className="logo-wrapper">
          <img src="/MP%20Full%20Color@3x.png" alt="Masters Path" className="site-logo-img" />
        </div>
      </div>

      <div className="policy-card">
        <h1>Terms of Service</h1>
        <p className="policy-effective">Effective Date: March 3, 2026</p>

        <hr className="policy-divider" />

        <div className="policy-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Masters Path Performance Dashboard ("the Platform"), you agree to be bound by
            these Terms of Service ("Terms"). If you do not agree to these Terms, you may not use the Platform.
            These Terms apply to all users, including dealership owners, managers, employees, and any other individuals
            granted access to the Platform.
          </p>
        </div>

        <div className="policy-section">
          <h2>2. Description of Service</h2>
          <p>
            The Platform is a web-based performance management application designed for powersports dealerships.
            It provides tools for data entry, analytics, reporting, goal tracking, and operational management for
            dealership owners, managers, and staff. Access to the Platform is provided by Masters Path Consulting LLC
            ("we," "us," or "our") under the terms described herein.
          </p>
        </div>

        <div className="policy-section">
          <h2>3. User Accounts</h2>
          <p>To use the Platform, you must be granted an account by an authorized administrator. You agree to:</p>
          <ul>
            <li>Provide accurate and complete information when your account is created.</li>
            <li>Maintain the confidentiality of your login credentials and not share them with others.</li>
            <li>Notify Masters Path Consulting LLC immediately at <a href="mailto:hb.masterspath@gmail.com" style={{color: '#ffb57a'}}>hb.masterspath@gmail.com</a> if you suspect unauthorized access to your account.</li>
            <li>Accept responsibility for all activity that occurs under your account.</li>
          </ul>
          <p>
            User accounts are issued to specific individuals and may not be shared, transferred, or used by anyone
            other than the individual to whom they were assigned without prior written authorization.
          </p>
        </div>

        <div className="policy-section">
          <h2>4. Acceptable Use</h2>
          <p>You agree to use the Platform only for its intended purposes and in compliance with applicable laws. You agree not to:</p>
          <ul>
            <li>Use the Platform for any unlawful, fraudulent, or unauthorized purpose.</li>
            <li>Attempt to gain unauthorized access to any part of the Platform, its servers, or related systems.</li>
            <li>Upload or transmit malicious code, viruses, or any content intended to disrupt or damage the Platform.</li>
            <li>Interfere with the operation of the Platform or the experience of other users.</li>
            <li>Attempt to reverse engineer, decompile, or disassemble any part of the Platform.</li>
            <li>Use automated tools, bots, or scripts to access or interact with the Platform without prior written consent.</li>
            <li>Circumvent or disable any security feature or access control.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>5. Data Ownership</h2>
          <p>
            You retain full ownership of all dealership data, business records, and other content you submit to the
            Platform ("Your Data"). Masters Path Consulting LLC does not claim ownership of Your Data and will not
            use it for purposes other than providing and improving the service as described in our Privacy Policy.
          </p>
          <p>
            By submitting data to the Platform, you grant Masters Path Consulting LLC a limited, non-exclusive license
            to store, process, and display Your Data solely for the purpose of operating the Platform on your behalf.
          </p>
        </div>

        <div className="policy-section">
          <h2>6. Confidentiality</h2>
          <p>
            Masters Path Consulting LLC will treat Your Data and any other non-public business information you share
            with us as confidential. We will not disclose Your Data to third parties except as necessary to operate the
            Platform, as required by law, or as described in our Privacy Policy. Our obligations under this section
            survive termination of your use of the Platform.
          </p>
        </div>

        <div className="policy-section">
          <h2>7. Intellectual Property</h2>
          <p>
            The Platform—including its software, design, user interface, features, and documentation—is the
            proprietary property of Masters Path Consulting LLC and is protected by applicable intellectual property
            laws. Nothing in these Terms grants you any ownership interest in the Platform.
          </p>
          <p>
            You may not copy, modify, distribute, sell, license, or create derivative works based on any part of the
            Platform without the prior written consent of Masters Path Consulting LLC.
          </p>
        </div>

        <div className="policy-section">
          <h2>8. Disclaimers</h2>
          <p>
            The Platform is provided "as is" and "as available" without warranties of any kind, either express or
            implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or
            non-infringement. Masters Path Consulting LLC does not warrant that the Platform will be continuously
            available, error-free, secure, or free of harmful components.
          </p>
          <p>
            Any reliance on data, analytics, or reports generated by the Platform is at your own discretion.
            Performance data should be independently verified before being used for significant business decisions.
          </p>
        </div>

        <div className="policy-section">
          <h2>9. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by applicable law, Masters Path Consulting LLC and its members, officers,
            employees, and agents shall not be liable for any indirect, incidental, special, consequential, or punitive
            damages—including loss of profits, data, goodwill, or business opportunities—arising out of or in
            connection with your use of or inability to use the Platform, even if advised of the possibility of such damages.
          </p>
          <p>
            In no event shall our total liability to you exceed the amount paid by you, if any, for access to the
            Platform in the twelve (12) months preceding the claim.
          </p>
        </div>

        <div className="policy-section">
          <h2>10. Termination</h2>
          <p>
            Masters Path Consulting LLC reserves the right to suspend or terminate your access to the Platform at any
            time, with or without notice, for violation of these Terms, non-payment, or for any other reason at our
            sole discretion. Upon termination, your right to use the Platform ceases immediately.
          </p>
          <p>
            You may request account deactivation at any time by contacting us at{" "}
            <a href="mailto:hb.masterspath@gmail.com" style={{color: '#ffb57a'}}>hb.masterspath@gmail.com</a>.
          </p>
        </div>

        <div className="policy-section">
          <h2>11. Modifications to These Terms</h2>
          <p>
            We may update these Terms from time to time to reflect changes in our practices, legal requirements, or
            platform features. We will make reasonable efforts to notify users of material changes, such as by updating
            the effective date above or by posting a notice within the Platform. Continued use of the Platform after
            changes are posted constitutes your acceptance of the updated Terms.
          </p>
        </div>

        <div className="policy-section">
          <h2>12. Governing Law</h2>
          <p>
            These Terms are governed by and construed in accordance with the laws of the State of Wisconsin, without
            regard to its conflict of law provisions. Any disputes arising under or in connection with these Terms shall
            be subject to the exclusive jurisdiction of the state and federal courts located in Wisconsin.
          </p>
        </div>

        <div className="policy-section">
          <h2>13. Contact</h2>
          <p>If you have questions or concerns about these Terms of Service, please contact us:</p>
          <div className="policy-contact-block">
            <p>
              <strong style={{color: 'rgba(220,235,255,0.92)'}}>Masters Path Consulting LLC</strong><br />
              <a href="mailto:hb.masterspath@gmail.com">hb.masterspath@gmail.com</a>
            </p>
          </div>
        </div>
      </div>

      <div className="policy-footer">
        <span>© {new Date().getFullYear()} Masters Path Consulting LLC</span>
        <span className="footer-sep">·</span>
        <Link to="/privacy">Privacy Policy</Link>
        <span className="footer-sep">·</span>
        <Link to="/account-deletion">Account Deletion</Link>
        <span className="footer-sep">·</span>
        <Link to="/login">Sign In</Link>
      </div>
    </div>
  );
}
